import { defineMessages } from 'react-intl';

export default defineMessages({
    loading: {
        id: 'ml.policychange.householdMembers.loading',
        defaultMessage: 'Loading...'
    },
    saving: {
        id: 'ml.policychange.householdMembers.saving',
        defaultMessage: 'Saving...'
    },
    makeChanges: {
        id: 'ml.policychange.householdMembers.makeChanges',
        defaultMessage: 'Make Changes'
    },
    nextBaseDescription: {
        id: 'ml.policychange.householdMembers.nextBaseDescription',
        defaultMessage: 'We\'ll check if {bold} next'
    },
    nextDescriptionBold: {
        id: 'ml.policychange.householdMembers.nextDescriptionBold',
        defaultMessage: 'additional changes are needed'
    },
    whatIsSecondaryNamedInsured: {
        id: 'ml.policychange.householdMembers.What is a secondary named insured',
        defaultMessage: 'What is a secondary named insured?'
    },
    definitionOfSecondaryNamedInsured: {
        id: 'ml.policychange.householdMembers.defination of secondary named insured',
        defaultMessage: 'A secondary named insured is typically the person who is co-titled on a vehicle or co-owner on a property deed. They have the same coverage under the policy as the named insured.'
    },
    addHouseholdMember: {
        id: 'ml.policychange.householdMembers.Add household member',
        defaultMessage: 'Add household member'
    },
    editHouseholdMember: {
        id: 'ml.policychange.householdMembers.Edit household member',
        defaultMessage: 'Edit household member'
    },
    addNonDriver: {
        id: 'ml.policychange.householdMembers.Add non driver',
        defaultMessage: 'Add non driver'
    },
    editNonDriver: {
        id: 'ml.policychange.householdMembers.Edit non driver',
        defaultMessage: 'Edit non driver'
    },
    notValidToRemoveHouseholdMember: {
        id: 'ml.policychange.householdMembers.The reason selected is not a valid reason to remove the secondary named insured. We require this person to be listed',
        defaultMessage: 'The reason selected is not a valid reason to remove the secondary named insured. We require this person to be listed.'
    },
    reasonSelectedIsNotValid: {
        id: 'ml.policychange.householdMembers.The reason selected is not a valid reason to remove this household member',
        defaultMessage: 'The reason selected is not a valid reason to remove this household member.'
    },
    reasonSelectedIsNotValidNonDriver: {
        id: 'ml.policychange.householdMembers.The reason selected is not a valid reason to remove this non driver',
        defaultMessage: 'The reason selected is not a valid reason to remove this non driver.'
    },
    licensedCannotBeExcluded: {
        id: 'ml.policychange.householdMembers.If licensed, the spouse can not be excluded from the policy',
        defaultMessage: 'If licensed, the spouse can not be excluded from the policy.'
    },
    driverExclusionHelpTitle: {
        id: 'ml.policychange.householdMembers.The driver must be either rated or excluded on this policy',
        defaultMessage: 'The driver must be either rated or excluded on this policy.'
    },
    driverExclusionHelpText: {
        id: 'ml.policychange.householdMembers.If selecting exclusion, a form will be required to be signed and there will be no coverage for that driver on this policy',
        defaultMessage: 'The reason selected is not a valid reason to remove a driver. If selecting exclusion, a form will be required to be signed and there will be no coverage for that driver on this policy.'
    },
    personListedAsDriver: {
        id: 'ml.policychange.householdMembers.We require this person to be listed as a driver',
        defaultMessage: 'The reason selected is not a valid reason to remove a household member. We require this person to be listed as a driver.'
    },
    nonDriverListedAsDriver: {
        id: 'ml.policychange.householdMembers.We require this non driver to be listed as a driver',
        defaultMessage: 'The reason selected is not a valid reason to remove a non driver. We require this person to be listed as a driver.'
    },
    removeHouseholdMember: {
        id: 'ml.policychange.householdMembers.Remove Household Member',
        defaultMessage: 'Remove Household Member'
    },
    removeNonDriver: {
        id: 'ml.policychange.householdMembers.Remove Non Driver',
        defaultMessage: 'Remove Non Driver'
    }

});
